/* ---------- TYPES ---------- */

export interface CMSComponent {
  uid: string;
  title: string;
  titleEn: string;
  childCategories?: string;
  sequence?: string;
  categoryIdentifier?: string;
}

export interface Service {
  id: string;
  title: string;
}

export interface Category {
  uid: string;
  title: string;
  services: Service[];
}

export interface ServiceProduct {
  id: string;
  categoryCode: string;
  productCode: string;
  title: string;
  description: string;
  displayType: string[];
  iconUrl: string | null;
  price: number;
  formattedPrice: string;
  product?: any;
}

export interface HomeMaintenanceCartEntry {
  productCode: string;
  categoryCode: string;
  description: string;
  imageUrls: string[];
  entryNumber?: string;
}

/* ---------- HELPERS ---------- */

export const splitUids = (str = '') => str.trim().split(/\s+/).filter(Boolean);

const isDefined = <T>(v: T | undefined): v is T => v !== undefined;

/* ---------- CATEGORY MAPPER ---------- */

export function mapCMSCategories(categories: CMSComponent[], childComponents: CMSComponent[]): Category[] {
  const childMap = new Map(childComponents.map(c => [c.uid, c]));

  return categories.map(category => ({
    uid: category.uid,
    title: category.title,
    titleEn: category.titleEn,
    services: splitUids(category.childCategories)
      .map(uid => childMap.get(uid))
      .filter(isDefined)
      .map(c => ({
        id: c.uid,
        title: c.title,
        categoryId: c.categoryIdentifier,
      })),
  }));
}

/* ---------- PRODUCT MAPPER ---------- */

export function mapProductsToServices(category: unknown): ServiceProduct[] {
  if (typeof category !== 'object' || category === null || !('products' in category) || !('code' in category)) {
    return [];
  }

  const cat = category as any;
  const products = Array.isArray(cat.products) ? cat.products : [];

  const categoryCode = String(cat.code);

  return products.map((p: any, i: number) => {
    const product = p?.product ?? {};
    const price = product?.price ?? {};

    const productCode = String(product.code ?? i);

    return {
      id: `${categoryCode}_${productCode}`,
      categoryCode,
      productCode,

      title: p?.title ?? '',
      description: p?.description ?? '',

      displayType: Array.isArray(p?.displayType) ? p.displayType : [],

      iconUrl: p?.iconUrl ?? null,

      price: Number(price.value ?? 0),
      formattedPrice: String(price.formattedValue ?? ''),

      product,
    };
  });
}

export function mapExistingServiceEntries(categoryResponse) {
  const mapped = {};

  categoryResponse.products?.forEach(service => {
    const existing = service.existingEntry?.extraServiceAppData;

    if (!existing) return;

    mapped[service.product.code] = {
      id: service.product.code,
      productCode: service.product.code,
      categoryCode: categoryResponse.code,
      description: existing.issueDescription || '',
      imageUrls: existing.imageUrls || [],
      isExisting: true,
      entryNumber: service.existingEntry?.entryNumber,
    };
  });

  console.log(mapped, 'mapped');

  return mapped;
}
